import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'orders'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getOrdersPost (payload) {
    return Client.post(`${resource}/get/get_orders_post`, parseFilters(payload))
      .then(response => response.data)
  },
  getOrder (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  calculateExpeditedShipping (payload) {
    return Client.post('orders/expedited/shipping', payload)
      .then(response => response.data)
  },
  calculateBusinessDays (manufacturerId, typeBook, days, format, start) {
    let fs = `days=${days}`
    fs = format ? `${fs}&format=${format}` : fs
    fs = start ? `${fs}&start=${start}` : fs
    fs = manufacturerId ? `${fs}&manufacturer_id=${manufacturerId}` : fs
    fs = typeBook ? `${fs}&type_book=${typeBook}` : fs
    return Client.get(`business_days?${fs}`)
      .then(response => response.data)
  },
  getYearbookCodes (filters) {
    return Client.get(`dpi_codes?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getYearbookCode (id, filters) {
    return Client.get(`dpi_codes/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getOrderXml (id) {
    return Client.get(`${resource}/${id}/xml`)
      .then(response => response.data)
  },
  updateOrderXml (data, id) {
    return Client.put(`${resource}/${id}/xml`, data)
      .then(response => response.data)
  },
  createQueuedOrderMove (data) {
    return Client.post('queue_moves/', data)
      .then(response => response.data)
  },
  getDirectoryFiles (id) {
    return Client.get(`orders/directory/contents/${id}`)
      .then(response => response.data)
  },
  getQuickbooksInvoiceStatus (invoiceNumber) {
    return Client.get(`${resource}/invoice/status/${invoiceNumber}`)
      .then(response => response.data)
  }
}
